<template>
	<div class="phvideos">
		<el-backtop ></el-backtop>
		<hpheader></hpheader>
		<div class="phpro-hea">{{vidcenter}}</div>
		<div class="videos">
			<div class="videos-left">
				<!-- <div class="videosleft-item" :class="videotopnavind==0?'viotopna':''" @click="videoclinav(0)">
					{{videonavall}}
				</div> -->
				<div class="videosleft-item" v-for="(item,index) in videoclassallss" :style="videotopnavind==item.id?'color:'+$store.state.themeColor:''" :key="index" @click="videoclinav(item.id)">
					{{item.name}}
				</div>
			</div>
			<div class="videos-right">
				<div class="videosright-heas">
					<div :style="videoinde==index?'color:'+$store.state.themeColor:''" class="videorighthea-item" v-for="(item,index) in prointrod" :key="index" @click="heanavvi(index)">
						{{item.vidtitle}}
					</div>
				</div>
				<div class="videosright-foots" v-for="(item,index) in videocontlist" :key="index">
					<div class="videosright-item" >
						<div class="videorightitem-hea">
							<video :src="item.video" :poster="item.image"  :id="'video'+item.id"></video>
							<div class="videobuts" @click="videopla(item.id)" v-if="item.mess1">
								<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phvideosimg/phvideoplay.png" />
							</div>
							<!-- <video-player
							  class="video-player vjs-custom-skin"
							  ref="videoPlayer"
							  :playsinline="true"
							  :options="playerOptions[index]"
							  @play="onPlayerPlay($event,index)"
							  @pause="onPlayerPause($event)"
							></video-player> -->
						</div>
						<div class="videoirghitem-foo">
							<div class="videoirghitem-left">
								{{item.title}}
							</div>
							<div class="videoirightitem-img" @click="downvideo(item)">
								<img src="../../assets/common/img/quanping.png" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<hpfooter></hpfooter>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	export default{
		data(){
			return{
				videoclassallss:[],
				videoclassliststtcontsecz:[],
				videocontlist:[],
				videonavnums:500,
				videoba:2,//视频大类(产品介绍,网络课程,案例分析)
				videotopnavind:0,
				id:'',
				videoinde:0,
				vitohomevid:false,
				vivideotcon:'',
				videonavall:'全部',
				vidcenter:'视频中心',
				prointrod:[],
				casesha:'案例分析',
				networkco:'显示更多',
				navheader:true,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				videoclassallss:'',
				videoclassliststt:[],
				videotopnavind:1,
				classidd:1,
				playsinline: true,
				playerOptions: [],
				videoc:'',
				options: "",
				value: '',
				valuelang: '',
			}
		},
		created() {
			this.videoinde = this.$route.query.e ? this.$route.query.e : 0
			window.scrollTo(0,0);
			this.videoclassall()
			this.videoclasslist()
			this.pageParam()
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
			
				this.$router.push({path:'./pcvideos',query:{e:this.$route.query.e}})
				return
			}
			this.ress()

		},
		components:{
			hpfooter,
			hpheader
		},
		methods:{
			videopla(e){
				console.log(e)
				for(let l =0; l<this.videocontlist.length;l++){
					if(e==this.videocontlist[l].id){
						let id=document.getElementById(`video${this.videocontlist[l].id}`)
						this.videocontlist[l].mess1=false
						id.play();
					}else{
						let id=document.getElementById(`video${this.videocontlist[l].id}`)
						this.videocontlist[l].mess1=true
						id.pause();
					}
							 
				}
			},
			downvideo(e){
				/* window.location.href=e.video; */
				/* window.open(e.video) */
				let a = document.createElement('a');
				a.href = e.video;
				a.download = e.title;
				a.click();

				/* document.createElement=e */
				/* var name = e.title;
				    var url = e.video;
				    var suffix = url.substring(url.lastIndexOf("."), url.length);
				      //跳过浏览直接下载
				    fetch(url)
				        .then(res => res.blob())
				        .then(blob => {
				        const a = document.createElement("a");
				        const objectUrl = window.URL.createObjectURL(blob);
				        a.download = name;
				        a.href = objectUrl;
				        a.click();
				        window.revokeObjectURL(objectUrl);
				    }) */
			},
			getMovieList() {
				this.playerOptions=[]
				/* console.log(this.videoclassliststtcontsecz[videoinde].list) */
			// 这里正常来说应该是从后台获取的数据，以下操作都是在成功的回调函数里
			  for (var i = 0; i < this.videoc.length; i++) {
			      let arrs = {
			        playbackRates: [1.0, 2.0, 3.0], //播放速度
			        autoplay: false, //如果true,浏览器准备好时开始回放。
			        muted: false, // 默认情况下将会消除任何音频。
			        loop: false, // 导致视频一结束就重新开始。
			        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
			        language: "zh-CN",
			        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
			        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
			        sources: [
			          {
			            type: "video/mp4",
			            type: "video/ogg",
						type: "video/webm",
			            src: this.videoc[i].video //url地址
			          }
			        ],
			        poster: this.videoc[i].image, //封面地址
			        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
			        controlBar: {
			          timeDivider: true,
			          durationDisplay: true,
			          remainingTimeDisplay: false,
			          fullscreenToggle: true //全屏按钮
			        }
			      };
			      this.playerOptions.push(arrs);
				  
			    }
			},
			onPlayerPlay(player, index) {
			   var that = this.$refs.videoPlayer;
			   console.log(that)
			   for (let i = 0; i < that.length; i++) {
			      if(i != index)
			      that[i].player.pause()
			   }
			},
			
			onPlayerPause(player) {
			},
			heanavvi(e){
				this.videoinde=e
				this.videoc=this.videoclassliststtcontsecz[this.videoinde].list
				this.videocontlist=[]
				this.videoc.map(((item, index)=> {
				this.videocontlist.push(Object.assign({},item,{mess1:true,mess2:8}))
				}))
				console.log(this.videocontlist)
				this.getMovieList()
			},
			videoclinav(e){
				this.videotopnavind=e
				this.classidd=e
				this.videoclasslist()
				this.getMovieList()
				
			},
			videoclasslist(){
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						mold:'pc',
						page:1,
						pageSize:500000,
						class_id:this.classidd,
					}
				this.$api.get_video_class_list(data).then((res) => {
						  this.videoclassliststt=res.data
						  this.videoclassliststtcontsecz=[]
						  this.videoclassliststt.map(((item, index)=> {
						  this.videoclassliststtcontsecz.push(Object.assign({},item,{mess1:true,mess2:8}))
						  }))
						  this.videoc=this.videoclassliststtcontsecz[this.videoinde].list
						  this.videocontlist=[]
						  this.videoc.map(((item, index)=> {
						  this.videocontlist.push(Object.assign({},item,{mess1:true,mess2:8}))
						  }))
						  console.log(this.videocontlist)
						  this.getMovieList()
				});
			},
			videoclassall(){
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						page:1,
						pageSize:this.videonavnums,
					}
						this.$api.get_video_class_all(data).then((res) => {
						this.videoclassallss=res.data
				});
			},
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.vidcenter = "视频中心"
					this.videonavall="全部"
					this.casesha="案例分析"
					this.networkco="显示更多"
					this.prointrod =  [
						{'vidtitle':'产品介绍'},
						{'vidtitle':'案例分析'},
						{'vidtitle':'网络课程'},
					]
				}else{
					this.vidcenter = "VIDEO"
					this.videonavall="all"
					this.casesha="Case sharing"
					this.networkco="Show more"
					this.prointrod =  [
						{'vidtitle':'Product introduction'},
						{'vidtitle':'Case sharing'},
						{'vidtitle':'Network course'},
					]
				}
			},
			
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phvideos{
		background: #FFF;
		padding-top: 0.88rem;
	}
	
	.phpro-hea{
		font-size: 0.36rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 0.4rem;
		margin-bottom: 0.32rem;
	}
	.prohea-nav{
		margin-bottom: 0.32rem;
	}
	.proheanav-cont{
		display: flex;
		flex-wrap: nowrap;
		overflow: auto;
	}
	.navcont-item{
		min-width: 2.1rem;
		width: 100%;
		text-align: center;
		/* margin-right: 0.12rem; */
		overflow: auto;
		font-size: 0.28rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
	}
	.navcont-item:first-child{
		margin-right: 0rem;
		margin-left: -0.06rem;
	}
	.phdetail-cont{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-bottom: 0.6rem;
	}
	.phdetailcont-item{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-bottom: 0.34rem;
	}
	.phdetailitem-hea{
		width: 6.9rem;
		height: 3.88rem;
		position: relative;
	}
	.phdetailitem-hea video{
		width: 100%;
		height: 100%;
		border-radius: 0.06rem;
	}
	.playimg{
		position: absolute;
		top: 1.51rem;
		left: 3.02rem;
	}
	.playimg img{
		width: 0.86rem;
		height: 0.86rem;
	}
	.phdetailitem-foo{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 6.9rem;
		margin-top: 0.25rem;
	}
	.phdetailitem-fooleft{
		font-size: 0.28rem;
		font-weight: 400;
		color: #5d5f5f;
	}
	.phdetailitem-fooright{
		width: 0.43rem;
		height: 0.43rem;
		display: flex;
	}
	.phdetailitem-fooright img{
		width: 100%;
		height: 100%;
	}
	.viotopna{
		color: #D03E3D;
	}
	.videos{
		display: flex;
	}
	.videos-left{
		width: 2.08rem;
		display: flex;
		flex-direction: column;
	}
	.videosleft-item{
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 0.34rem;
		font-size: 0.24rem;
		font-weight: 500;
		height: 0.96rem;
		background: #F5F5F5;
		color: #5d5f5f;
	}
	.videos-right{
		width: 4.96rem;
		margin-left: 0.24rem;
	}
	.videosright-heas{
		display: flex;
		align-items: center;
		margin-bottom: 0.32rem;
	}
	.videorighthea-item{
		font-size: 0.24rem;
		font-weight: 400;
		color: #5d5f5f;
		margin-left: 0.76rem;
		text-align: center;
		
	}
	.videorighthea-item:first-child{
		margin-left: 0;
		
	}
	.videosright-foots{
		
	}
	.videosright-item{
		margin-bottom: 0.36rem;
	}
	.videorightitem-hea{
		width: 4.96rem;
		height: 2.8rem;
		position: relative;
	}
	.videorightitem-hea video{
		width: 4.96rem;
		height: 2.8rem;
	}
	.videobuts{
		width: 4.96rem;
		height: 2.8rem;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
	}
	.videobuts img{
		width: 0.8rem;
		height: 0.8rem;
	}
	.videoirghitem-foo{
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 0.32rem;
	}
	.videoirghitem-left{
		font-size: 0.24rem;
		font-weight: 400;
		color: #5d5f5f;
	}
	.videoirightitem-img{
		width: 0.4rem;
		height: 0.4rem;
		display: flex;
	}
	.videoirightitem-img img{
		width: 0.4rem;
		height: 0.4rem;
	}
	.cc{
		color: #D03E3D;
	}
	.viotopna{
		background-color: #fff;
		color: #D03E3D;
	}
	.video-js .vjs-control-bar button{
	  outline: none;
	}
	.vjs-modal-dialog .vjs-modal-dialog-content, .video-js .vjs-modal-dialog, .vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before{
		
	}
	.vjs-custom-skin > .video-js .vjs-big-play-button{
		
	}
</style>
